module.exports = "https://static.wmbcdn.com/uniweb/images/afe36d015474189d6a383032f8c3cb59.woff2";